import { Theme } from './themesTypes';

export const lightTheme: Theme = {
  isDark: false,
  primary: '#FF6A00',
  primaryDark: '#DC5C01',
  primaryLight: '#FAC8B2',
  secondary: '#35829E',
  secondaryDark: '#1A4A5A',
  secondaryLight: '#B8D9E6',
  background1: '#FFFFFF',
  background2: '#F5F5F5',
  background3: '#EEEEEE',
  text: '#333333',
  textLight: '#666666',
  textCTA: '#FFFFFF',
  link: '#FF6A00',
  fill1: '#FF6A00',
  fill2: '#DC5C01',
  fill3: '#FAC8B2',
  stroke: '#E0E0E0',
};

export const darkTheme: Theme = {
  isDark: true,
  primary: '#FF6A00',
  primaryDark: '#DC5C01',
  primaryLight: '#FAC8B2',
  secondary: '#35829E',
  secondaryDark: '#1A4A5A',
  secondaryLight: '#B8D9E6',
  background1: '#121212',
  background2: '#1E1E1E',
  background3: '#2D2D2D',
  text: '#FFFFFF',
  textLight: '#B0B0B0',
  textCTA: '#FFFFFF',
  link: '#FF6A00',
  fill1: '#FF6A00',
  fill2: '#DC5C01',
  fill3: '#FAC8B2',
  stroke: '#404040',
};

// Export a single themes object for convenience
export const themes = {
  light: lightTheme,
  dark: darkTheme,
};
